import { ItemAnalyticsModel } from '@/@types/client-api/models/ItemAnalyticsModel';
import { AnalyticsContext, AnalyticsEventName } from './constants';
import { trackEvent } from './utils';
import { ConvertItemAnalyticsModelBase } from './analyticsUtils';

export const selectKeyTakeaway = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  trackEvent({
    eventName: AnalyticsEventName.SelectKeyTakeaway,
    parameters: {
      context: AnalyticsContext.KeyTakeaway,
      method: 'PDP',
      items: [{ ...ConvertItemAnalyticsModelBase(itemAnalyticsModel) }]
    }
  });
};

export const viewKeyTakeaway = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  trackEvent({
    eventName: AnalyticsEventName.ViewKeyTakeaway,
    parameters: {
      context: AnalyticsContext.KeyTakeaway,
      method: 'PDP',
      items: [{ ...ConvertItemAnalyticsModelBase(itemAnalyticsModel) }]
    }
  });
};

export const copyKeyTakeaway = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  trackEvent({
    eventName: AnalyticsEventName.CopyKeyTakeaway,
    parameters: {
      context: AnalyticsContext.KeyTakeaway,
      items: [{ ...ConvertItemAnalyticsModelBase(itemAnalyticsModel) }]
    }
  });
};

export const rateKeyTakeaway = (liked?: boolean, itemAnalyticsModel?: ItemAnalyticsModel) => {
  trackEvent({
    eventName: AnalyticsEventName.RateKeyTakeaway,
    parameters: {
      context: AnalyticsContext.KeyTakeaway,
      method: liked ? 'Positive' : 'Negative',
      items: [{ ...ConvertItemAnalyticsModelBase(itemAnalyticsModel) }]
    }
  });
};

export const feedbackKeyTakeaway = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  trackEvent({
    eventName: AnalyticsEventName.FeedbackKeyTakeaway,
    parameters: {
      context: AnalyticsContext.KeyTakeaway,
      items: [{ ...ConvertItemAnalyticsModelBase(itemAnalyticsModel) }]
    }
  });
};
